export default __webpack_public_path__ + "static/media/manageDesktop.a0499e02.webp";